import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular/lib/interfaces';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-checkbox-cell-renderer',
  templateUrl: './checkbox-cell-renderer.component.html',
  styleUrls: ['./checkbox-cell-renderer.component.scss']
})

export class CheckboxCellRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams & {
    isEditable: boolean
  };
  agInit(params: ICellRendererParams & {
    isEditable: boolean
  }): void {
    this.params = params;
  }
  refresh(params: ICellRendererParams & {
    isEditable: boolean
  }): boolean {
    this.params = params;
    return true
  }
  setCheckState($event: any) {
    let checked = $event.detail.isChecked;
    let colId = this.params.column?.getColId() as string;
    this.params.node.setDataValue(colId, checked);

    //Additional code block to support TFBool Type
    let field: string = this.params.column?.getColDef().field as string;
    let fieldObj: any = this.params.node.data[field.split('.')[0]];
    if (typeof fieldObj?.value === "string") {
      fieldObj.value = checked ? 'Y' : 'N';
    }
    if (typeof fieldObj?.intValue === "number") {
      fieldObj.intValue = checked ? 1 : 0;
    }
  }
}
